import { z } from 'zod';

interface ErrorResponse {
	error: string;
}

export const ErrorResponseSchema: z.ZodType<ErrorResponse> = z.object({
	error: z.string(),
});
